import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import routes from "../utils/routes";
import useAxiosPrivate from "./useAxiosPrivate";
import EndpointFunctions from "../utils/Functions/endpointFunctions";
import { broadcastAuthCleared } from "../auth/authChannel";

const useLogout = () => {
  const { setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const logout = async () => {
    setAuth({});
    // Other open tabs of this user must also drop their auth state, otherwise
    // they keep an access token the backend has just revoked.
    broadcastAuthCleared();
    try {
      await EndpointFunctions.postData({
        endpointURL: "backoffice/logout",
        axiosPrivate: axiosPrivate,
      });

      navigate(routes.login);
    } catch (err) {
      console.error(err);
    }
  };

  return { logout };
};

export default useLogout;
